import i18n from "../i18n";

const createMinLengthRule = (minLength: number) => (value: string) =>
  (value && value.length >= minLength) || i18n.tc("at_least_x_chars", minLength).toString();

const createMaxLengthRule = (maxLength: number) => (value: string) =>
  value === "" || value.length <= maxLength || i18n.tc("max_x_chars", maxLength).toString();

const createMinNumberRule = (minNumber: number) => (value: string | number) =>
  (value !== "" && parseFloat(`${value}`) >= minNumber) || i18n.t("min_value_x", { x: minNumber }).toString();

const createMaxNumberRule = (maxNumber: number) => (value: string | number) =>
  (value !== "" && parseFloat(`${value}`) <= maxNumber) || i18n.t("max_value_x", { x: maxNumber }).toString();

const rules: Record<string, any> = {
  minLength: createMinLengthRule,
  maxLength: createMaxLengthRule,
  minNumber: createMinNumberRule,
  maxNumber: createMaxNumberRule,
  required: (value: string) => !!value || i18n.t("required").toString(),
  email: (value: string) => value === "" || /.+@.+/.test(value) || i18n.t("email_is_invalid").toString(),
  integer: (value: string) => value === "" || /^[0-9]+$/.test(value) || i18n.t("only_numbers").toString(),
  passwordLength: createMinLengthRule(6),
};

export default rules;
